var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.editor)?_c('div',[_c('editor-content',{attrs:{"editor":_vm.editor}})],1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }